import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import {
  AddPayoutAccountACHFormProps,
  DwollaAchFormHandle,
} from './AddPayoutAccountACHForm.types';

const AddPayoutAccountACHForm = forwardRef<
  DwollaAchFormHandle,
  AddPayoutAccountACHFormProps
>(({ providerCustomerID, onReadyChange }, ref) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const getSubmitEl = () => {
    const host = containerRef.current?.querySelector(
      'dwolla-funding-source-create',
    ) as (HTMLElement & { shadowRoot?: ShadowRoot }) | null;

    const shadow = host?.shadowRoot;
    if (shadow) {
      return shadow.querySelector<HTMLInputElement>('input[type="submit"]');
    }

    return containerRef.current?.querySelector<HTMLInputElement>(
      '.dwolla-funding-source-submit input[type="submit"], input[type="submit"]',
    );
  };

  useImperativeHandle(ref, () => ({
    submit: () => getSubmitEl()?.click(),
  }));

  useEffect(() => {
    if (!onReadyChange) return;

    const host = containerRef.current?.querySelector(
      'dwolla-funding-source-create',
    ) as (HTMLElement & { shadowRoot?: ShadowRoot }) | null;

    const rootToObserve: Node | null = host?.shadowRoot ?? containerRef.current;

    if (!rootToObserve) return;

    const updateReady = () => {
      const el = getSubmitEl();
      const ready =
        !!el && !el.disabled && el.getAttribute('aria-disabled') !== 'true';
      onReadyChange(ready);
    };

    updateReady();

    const obs = new MutationObserver(updateReady);
    obs.observe(rootToObserve, {
      subtree: true,
      childList: true,
      attributes: true,
    });

    return () => obs.disconnect();
  }, [onReadyChange]);

  return (
    <div ref={containerRef}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <dwolla-funding-source-create customerId={providerCustomerID} />
    </div>
  );
});

export default AddPayoutAccountACHForm;
